<template>
    <v-collapse-group :only-one-active="true">
        <transition-group
            tag="div"
            name="staggered-fade"
            :css="false"
            class="row"
            @before-enter="beforeEnter"
            @enter="enter"
            @leave="leave"
        >
            <v-collapse-wrapper
                v-for="(cardData, index) in members"
                :key="cardData.id"
                :class="'d-flex flex-column col-lg-4 col-sm-6'"
            >
                <component
                    :is="'members'"
                    :read-more="'Vergadergroepen'"
                    :card-data="cardData"
                    :data-index="index"
                />
            </v-collapse-wrapper>
        </transition-group>
    </v-collapse-group>
</template>

<script>
import memberCard from '@/components/members/member-card';
import overview from '@/mixins/overview.js';
import transition_staggered_fade from '@/mixins/transition-staggered-fade-mixin.js';
import translationMixin from '@/mixins/translations';

export default {
    components: {
        members: memberCard
    },
    mixins: [overview, transition_staggered_fade, translationMixin],
    props: {
        members: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            searchCategory: 'members',
            searchCategoryLabel: this.translations.members,
            currentCardComponent: 'members',
            currentNodeId: ''
        };
    }
};
</script>
